import { ClassicEditor } from '@foxtaibox/foxtailbox-frontend-core';
import { ClipboardEvent, DragEvent } from 'react';
import { registerInsert } from 'store/assessment/model';

interface IUseInsertTrackingReturn {
  handleEditorReady: (editor: ClassicEditor) => void;
  textFieldInsertHandlers: {
    onPaste: (event: ClipboardEvent<HTMLDivElement>) => void;
    onDrop: (event: DragEvent<HTMLDivElement>) => void;
  };
}

// Длина считается по text/plain: он есть в буфере при любом копировании текста
// (в том числе кнопкой «Копировать» в ИИ-чатах, где text/html нет)
const getInsertedLength = (dataTransfer: Pick<DataTransfer, 'getData'> | null) =>
  dataTransfer?.getData('text/plain').length ?? 0;

/**
 * Прокторинг вставок в поле ответа: учитывает и вставку из буфера (Ctrl+V), и перетаскивание (drop).
 * Счётчики копятся в сторе ($insertCount, $insertSymbols) и сбрасываются через resetAnswerMetadata.
 */
const useInsertTracking = (): IUseInsertTrackingReturn => {
  // clipboardInput срабатывает в CKEditor и на paste, и на drop
  const handleEditorReady = (editor: ClassicEditor) => {
    editor.editing.view.document.on('clipboardInput', (_, data) => {
      registerInsert(getInsertedLength(data.dataTransfer));
    });
  };

  const onPaste = (event: ClipboardEvent<HTMLDivElement>) => {
    registerInsert(getInsertedLength(event.clipboardData));
  };

  const onDrop = (event: DragEvent<HTMLDivElement>) => {
    registerInsert(getInsertedLength(event.dataTransfer));
  };

  return {
    handleEditorReady,
    textFieldInsertHandlers: { onPaste, onDrop },
  };
};

export default useInsertTracking;
